export default __webpack_public_path__ + "static/media/persevere_0.f79d846f.jpg";